import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { assessor_group_list_loading : true, assessor_group_list: '', assessor_group_list_error: false};

export function AsessorGroupList(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_ASSESSOR_GROUP_LIST:
        return {
            assessor_group_list_loading: true,
            assessor_group_list: '',
            assessor_group_list_error: false
        };
      case dashBoardConstants.RECIEVE_ASSESSOR_GROUP_LIST:
        return {
            assessor_group_list_loading: false,
            assessor_group_list: action.assessor_group_list,
            assessor_group_list_error: false
        };
      case dashBoardConstants.ERROR_ASSESSOR_GROUP_LIST:
        return { 
            assessor_group_list_loading: false,
            assessor_group_list: '',
            assessor_group_list_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/assesserGroupList.reducer.js